import { Client } from "../projects";
import { IConverter, TSnapshot } from "./generics";

export const clientConverter: IConverter<Client> = {
  toFirestore(client: Client) {
    return client;
  },
  fromFirestore(snapshot: TSnapshot): Client {  
    const data = snapshot.data();
    return {
      id: snapshot.id,
      createdByUserId: data?.createdByUserId || "",
      legalOwnerFirebaseId: data?.legalOwnerFirebaseId || "",
      companyName: data?.companyName || "",
      logoUrl: data?.logoUrl || "",
      pointOfContactName: data?.pointOfContactName || "",
      email: data?.email || "",
      phone: data?.phone || "",
      location: data?.location || "",
      size: data?.size || "",
      status: data?.status || "opportunity",
      introductionDate: data?.introductionDate || new Date().toISOString(),
      associatedFreelancerIds: data?.associatedFreelancerIds || [],
      associatedStakeholderIds: data?.associatedStakeholderIds || [],
      companyPhysicalAddress: data?.companyPhysicalAddress || {
        street: "",
        city: "",
        state: "",
        zip: "",
      },
    };
  },
};
